import { useSelector, clientDocsActions } from "inbooma-api";
import ClientDocsSidebar from "./ClientDocsSidebar";
import SortNav from "../../../components/SortNav";
import Paginator from "../../../components/paginator";
import ClientDocsList from "./ClientDocsList";
import Loader from "../../../components/Loader";
import ItemView from "./ItemView";
import React, { useEffect, useState } from "react";
import { getAllUrlParams, Notification } from "../../../../utils";
import { $, _ } from "../../../../../vendor";
import { moment } from "../../../../../vendor";

const ClientDocumentsView = (props) => {
  const { params, name, dispatch, returnPath, rbac, isViewVisible, t, Biscuit, language } = props;
  const currentUrl = new URL(window.location.href);
  const searchParams = currentUrl.searchParams;
  const allUrlParams = getAllUrlParams(window.location.href);
  const allUrlParamsClone = { ...allUrlParams };
  allUrlParams?.location_name !== undefined && delete allUrlParams.location_name;
  const _clientDocs = useSelector((state) => state.client_docs_data.getClientDocs);
  const _clientDoc = useSelector((state) => state.client_docs_data.getClientDoc);
  const _addClientDoc = useSelector((state) => state.client_docs_data.addClientDoc);
  const _editClientDoc = useSelector((state) => state.client_docs_data.editClientDoc);

  const [clientDocsPending, setClientDocsPending] = useState(false);
  const [clientDocPending, setClientDocPending] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const [filter, setFilter] = useState({
    find: "full",
    ...allUrlParams,
  });
  const [sort, setSort] = useState({
    sort: allUrlParamsClone?.sort !== undefined ? allUrlParamsClone.sort : "description",
    direction: allUrlParamsClone?.direction !== undefined ? allUrlParamsClone.direction : "asc",
  });
  const [_key, setKey] = useState(null);
  const paginationLimit = 100;
  const [pagination, setPagination] = useState({
    has_next_page: false,
    current_page: 1,
  });
  const [resetFilter, setResetFilter] = useState(false);
  const _queryState = {
    timeStamp: 0,
    value: "",
  };
  function containsNumbers(str) {
    return /\d/.test(str);
  }

  useEffect(() => {
    if (!initialized) {
      dispatch(
        clientDocsActions.getClientDocs({
          token: Biscuit.get("token"),
          parameters: {
            headers: {
              "Accept-Language": language,
            },
          },
        }),
      );
      setClientDocsPending(true);

      if (params !== null) {
        if (containsNumbers(params[0])) {
          dispatch(
            clientDocsActions.getClientDoc({
              token: Biscuit.get("token"),
              id: params[0],
              parameters: {
                headers: {
                  "Accept-Language": language,
                },
              },
            }),
          );
          setClientDocPending(true);
        }
      }
    }
  }, []);

  useEffect(() => {
    if (!clientDocsPending || _clientDocs.success === "") {
      return;
    }
    setClientDocsPending(false);
    setInitialized(true);
  }, [_clientDocs]);

  useEffect(() => {
    if (!clientDocPending || _clientDoc.success === "") {
      return;
    }
    setClientDocPending(false);
    setInitialized(true);
  }, [_clientDoc]);

  useEffect(() => {
    if (!clientDocPending || _addClientDoc.success === "") {
      return;
    }
    setClientDocPending(false);
  }, [_addClientDoc]);

  useEffect(() => {
    if (!clientDocPending || _editClientDoc.success === "") {
      return;
    }
    setClientDocPending(false);
  }, [_editClientDoc]);

  const loadNextPage = () => {
    //  if (!pagination.has_next_page) return;

    setClientDocsPending(true);
    // request next page
    dispatch(
      clientDocsActions.getClientDocs({
        token: Biscuit.get("token"),
        filter: {
          ...filter,
          page: pagination.current_page + 1,
          limit: pagination.limit,
        },
        parameters: {
          headers: {
            "Accept-Language": language,
          },
        },
      }),
    );
  };

  const showNotification = (msgType, itemId, errorMsg = "") => {
    if (msgType === "success") {
      new Notification({
        message: t("saved_${a}", { a: name }, "capital") + " #" + itemId,
        duration: 5000,
        type: "success",
        closeable: true,
        icon: "fi fi-check",
      });
    } else if (msgType === "warning") {
      new Notification({
        message: errorMsg,
        duration: 5000,
        type: "warning",
        closeable: true,
        icon: "fi fi-x",
      });
    }
  };

  const tabs = [
    {
      name: t("id", null, "capital"),
      smallWidth: 3,
      mediumWidth: 3,
      title: t("sort_by_${a}", { a: t("id") }, "capital"),
      canSort: true,
      preselected: true,
      sort: {
        direction: sort.direction,
        data_inb_val: sort.sort,
      },
    },
    {
      name: t("description", null, "capital"),
      smallWidth: 6,
      mediumWidth: 6,
      title: t("description", null, "capital"),
      canSort: true,
      sort: {
        direction: sort.direction,
        data_inb_val: sort.sort,
      },
    },
    {
      name: t("pdf", null, "capital"),
      smallWidth: 3,
      mediumWidth: 3,
      title: t("pdf", null, "capital"),
      canSort: false,
    },
  ];

  const onSortChangedHandle = (ev) => {
    const el = ev.currentTarget;
    const sortKey = el.getAttribute("data-inb-val"),
      direction = el.getAttribute("data-inb-direction"),
      isOppositeElement = direction === null && el.classList.contains("is-active"),
      newDirection = direction === "desc" || isOppositeElement ? "asc" : "desc";

    if (sortKey) {
      let requestFilter;
      if (typeof filter.limit !== "undefined") {
        requestFilter = {
          ...filter,
          sort: sortKey,
          direction: direction,
        };
      } else {
        requestFilter = {
          ...filter,
          sort: sortKey,
          direction: direction,
          limit: paginationLimit,
          page: 1,
        };
      }

      dispatch(
        clientDocsActions.getClientDocs({
          token: Biscuit.get("token"),
          suffix: "",
          filter: requestFilter,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setClientDocsPending(true);
      setSort({
        sort: sortKey,
        direction: direction,
      });

      const activeSortTab = $(".is-active");
      _.each(activeSortTab, function (key) {
        key["classList"].remove("is-active");
      });
      el.classList.add("is-active");
      el.setAttribute("data-inb-direction", isOppositeElement ? "desc" : newDirection);
    }
  };

  const filterChangedHandle = (filter, sorts = null) => {
    let requestFilter = { ...filter };
    if (sorts === null) {
      sorts = sort;
    } else {
      setSort(sorts);
    }
    requestFilter.sort = sorts.sort;
    requestFilter.direction = sorts.direction;
    if (typeof filter.limit !== "undefined") {
      requestFilter.limit = filter.limit;
      if (typeof requestFilter.page !== "undefined") {
        delete requestFilter.page;
      }
    } else {
      requestFilter.limit = paginationLimit;
      requestFilter.page = 1;
    }
    dispatch(
      clientDocsActions.getClientDocs({
        token: Biscuit.get("token"),
        suffix: "",
        filter: requestFilter,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setClientDocsPending(true);
    setFilter(filter);
  };

  return (
    <>
      <ClientDocsSidebar
        dispatch={dispatch}
        heading={name}
        rbac={rbac}
        filter={filter}
        setFilter={setFilter}
        resetFilter={resetFilter}
        setResetFilter={setResetFilter}
        initialized={!clientDocsPending}
        sort={sort}
        setSort={setSort}
        t={t}
        name={name}
        Biscuit={Biscuit}
        moment={moment}
        /*summary={summary}
           summaryPending={summaryPending}*/
      />
      <div id="inb-c-main" className="columns">
        <div className="sticky-container" style={{ height: "59px" }}>
          <SortNav tabs={tabs} listStyle="tight" handler={onSortChangedHandle} />
        </div>
        {initialized && _clientDocs?.data?.length > 0 && typeof pagination !== "undefined" && (
          <Paginator
            pagination={pagination}
            itemsCountPerPage={paginationLimit}
            pageRangeDisplayed={5}
            onChange={loadNextPage}
          />
        )}
        <div className="off-canvas-wrapper">
          {_clientDocs?.data?.length > 0 && initialized && (
            <ClientDocsList
              clientDocs={_clientDocs?.data}
              dispatch={dispatch}
              filterChangedHandle={filterChangedHandle}
              filter={filter}
              setFilter={setFilter}
              sort={sort}
              setSort={setSort}
              language={language}
              _key={_key}
              setKey={setKey}
              params={params}
              rbac={rbac}
              Biscuit={Biscuit}
              showNotification={showNotification}
              moment={moment}
              t={t}
            />
          )}
          {_clientDocs?.data?.length < 1 && (
            <>
              <div
                id="inb-app-collection-empty"
                className="inb-announcement"
                style={{ minHeight: "1150px" }}
              >
                <div className="inb-image-box">
                  <img alt="No Data" src={"assets/img/no_data.svg"} />
                </div>
                <h3>{t("app_msg_collection_empty")}</h3>
                <p>{t("app_msg_collection_empty_body")}</p>
              </div>
            </>
          )}
          {initialized && _clientDocs?.data?.length > 0 && typeof pagination !== "undefined" && (
            <Paginator
              pagination={pagination}
              itemsCountPerPage={paginationLimit}
              pageRangeDisplayed={5}
              onChange={loadNextPage}
            />
          )}
          {clientDocsPending && <Loader mediumWidth={2} smallWidth={4} subLoaders={5} />}
        </div>
      </div>
      {params !== null &&
        (params[0] === "add" || (containsNumbers(params[0]) && typeof params[1] === "undefined")) &&
        initialized &&
        !clientDocPending && (
          <ItemView
            dispatch={dispatch}
            clientDocsActions={clientDocsActions}
            clientDoc={_clientDoc?.data}
            isEdit={containsNumbers(params[0]) && typeof params[1] === "undefined"}
            language={language}
            params={params}
            requestPath={returnPath}
            showNotification={showNotification}
            setFilter={setFilter}
            filter={filter}
            currentUrl={new URL(window.location.href)}
            t={t}
            moment={moment}
            Biscuit={Biscuit}
            rbac={rbac}
          />
        )}
    </>
  );
};

export default ClientDocumentsView;
